import { MenuItem, Select } from "@mui/material";

export function EditableSelectCell({
  value = "",
  options = [],
  onChange = () => {},
  ...restProps
}) {
  return (
    <Select
      value={options?.length ? value || "" : ""}
      fullWidth 
      disableUnderline
      variant="standard"
      sx={{
        bgcolor: "transparent",
        "& .MuiSelect-select": {
          py: 0.5,
          px: 1,
          fontSize: "0.7rem",
          lineHeight: 1.2,
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "visible",
          textOverflow: "clip",
        },
      }}
      onChange={(e) => onChange(e.target.value)}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 400,
            overflowY: "auto",
          },
        },
        MenuListProps: {
          style: {
            maxHeight: 400,
          },
        },
      }}
      {...restProps}
    >
      {options.map((option, index) => (
        <MenuItem key={index} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
}
